<div class="dialog-header">

  <div class="header-title">
		<span style="font-size: 120%;">

		</span>
  </div>
  <button mat-button class="close-button-container" mat-dialog-close disableRipple="true">
    <mat-icon>clear</mat-icon>
  </button>
</div>
<div class="middle-content">
  <app-installation-quote-body [quote]="quote"></app-installation-quote-body>
</div>
